'use client';

import { c as _c } from "react/compiler-runtime";
import SwatchSetOnPage from './SwatchSetOnPage';
import SwatchSetModal from './SwatchSetModal';
const SwatchSetContainer = t0 => {
  const $ = _c(18);
  const {
    swatchSet,
    selectSwatch,
    selectedSwatch,
    swatchSetErrors,
    displayErrors,
    swatchFavorites: t1,
    variant,
    productInfo
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const swatchFavorites = t2;
  if (swatchSet.layout_type == 2) {
    let t3;
    if ($[2] !== displayErrors || $[3] !== selectSwatch || $[4] !== selectedSwatch || $[5] !== swatchFavorites || $[6] !== swatchSet || $[7] !== swatchSetErrors) {
      t3 = <SwatchSetOnPage swatchSet={swatchSet} selectSwatch={selectSwatch} selectedSwatch={selectedSwatch} swatchSetErrors={swatchSetErrors} displayErrors={displayErrors} swatchFavorites={swatchFavorites} />;
      $[2] = displayErrors;
      $[3] = selectSwatch;
      $[4] = selectedSwatch;
      $[5] = swatchFavorites;
      $[6] = swatchSet;
      $[7] = swatchSetErrors;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    return t3;
  }
  let t3;
  if ($[9] !== displayErrors || $[10] !== productInfo || $[11] !== selectSwatch || $[12] !== selectedSwatch || $[13] !== swatchFavorites || $[14] !== swatchSet || $[15] !== swatchSetErrors || $[16] !== variant) {
    t3 = <SwatchSetModal swatchSet={swatchSet} selectSwatch={selectSwatch} selectedSwatch={selectedSwatch} swatchSetErrors={swatchSetErrors} displayErrors={displayErrors} swatchFavorites={swatchFavorites} variant={variant} productInfo={productInfo} />;
    $[9] = displayErrors;
    $[10] = productInfo;
    $[11] = selectSwatch;
    $[12] = selectedSwatch;
    $[13] = swatchFavorites;
    $[14] = swatchSet;
    $[15] = swatchSetErrors;
    $[16] = variant;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
};
export default SwatchSetContainer;